export function makeResponsiveFrames() {
	const frames = document.querySelectorAll('iframe');
	if (!frames || !frames.length) {
		return;
	}

	
	frames.forEach(frame => {
		console.log(frame.closest('.embed-wrapper'));
		const hasEmbedWrapper = !!frame.closest('.embed-wrapper');
		if (hasEmbedWrapper) {
			return;
		}

		const height = frame.getAttribute('height');
		const width = frame.getAttribute('width');

		if (height && width) {
			const wrapper = document.createElement('div');
			wrapper.style.setProperty('--aspect-width', width);
			wrapper.style.setProperty('--aspect-height', height);
			wrapper.classList.add('embed-wrapper');
			wrapper.classList.add('embed-wrapper--dynamic-ratio');

			frame.parentElement.insertBefore(wrapper, frame);
			wrapper.appendChild(frame);
		}
	});

}



// WEBPACK FOOTER //
// ./scripts/modules/responsive-frames.js